import UnderwritingMultiTenant from "../../UnderwritingMultiTenant";

export default {
    name: 'Expenses',
    tables: {
        'general-information': {
            rows: {
                'date': {
                    valueCells: [{
                        editable: false,
                        getComputedValue(tabs) {
                            const analysisDate = tabs['pricing-tab'].tables['pricing-analysis'].rows['pricing-analysis'].valueCells[1].value;
                            let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                            const value = analysisDate ? new Date(analysisDate) : '';
                            const displayValue = value ? `${months[value.getMonth()]} ${value.getFullYear()}` : '';
                            return {internalValue: value, displayValue: `${displayValue.toLocaleString()}`};
                        }
                    }]
                }
            },
        },
        'expenses': {
            rows: {
                'header': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'EXPENSES'};
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: true,
                        value: ''
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'PSF'};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: 'Proforma'};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: 'PSF'};
                        }
                    },]
                },
                'real-estate-taxes': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Real Estate Taxes'};
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        type: 'number',
                        unit: '$',
                        editable: true,
                        value: ''
                    }, {
                        editable: false,
                        tooltip: 'real_estate_taxes / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const totalSpace = tabs['current-rr-tab'].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                            const current = tabs['expenses-tab'].tables['expenses'].rows['real-estate-taxes'].valueCells[2].value;
                            const value = parseFloat(current / totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value)  || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        type: 'number',
                        unit: '$',
                        editable: true,
                        hidden: true,
                        value: ''
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: 'real_estate_taxes / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const totalSpace = tabs['current-rr-tab'].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                            const current = tabs['expenses-tab'].tables['expenses'].rows['real-estate-taxes'].valueCells[5].value;
                            const value = parseFloat(current / totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    },]
                },
                'insurance': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Insurance'};
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        type: 'number',
                        unit: '$',
                        editable: true,
                        value: ''
                    }, {
                        editable: false,
                        tooltip: 'insurance / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const totalSpace = tabs['current-rr-tab'].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                            const current = tabs['expenses-tab'].tables['expenses'].rows['insurance'].valueCells[2].value;
                            const value = parseFloat(current / totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value)  || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        type: 'number',
                        unit: '$',
                        editable: true,
                        hidden: true,
                        value: ''
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: 'insurance / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const totalSpace = tabs['current-rr-tab'].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                            const current = tabs['expenses-tab'].tables['expenses'].rows['insurance'].valueCells[5].value;
                            const value = parseFloat(current / totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    },]
                },
                'cam-title': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'CAM'};
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    },]
                },
                'cam-1': {
                    valueCells: [{
                        editable: true,
                        value: '',
                        hasRowManipulation: true
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        type: 'number',
                        unit: '$',
                        editable: true,
                        value: ''
                    }, {
                        editable: false,
                        tooltip: 'cam / total_sq_ft',
                        getComputedValue(tabs, precomputedValues, rowIndex) {
                            const totalSpace = tabs['current-rr-tab'].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                            const current = tabs['expenses-tab'].tables['expenses'].rows[rowIndex].valueCells[2].value;
                            const value = parseFloat(current / totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value)  || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        type: 'number',
                        unit: '$',
                        editable: true,
                        hidden: true,
                        value: ''
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: 'cam / total_sq_ft',
                        getComputedValue(tabs, precomputedValues, rowIndex) {
                            const totalSpace = tabs['current-rr-tab'].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                            const current = tabs['expenses-tab'].tables['expenses'].rows[rowIndex].valueCells[5].value;
                            const value = parseFloat(current / totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, { // leave ARCIMEDES_ROW_ID as the last cell
                        type: 'string',
                        editable: true,
                        hidden: true,
                        value: '',
                    },]
                },
                'cam-2': {
                    valueCells: [{
                        editable: true,
                        value: '',
                        hasRowManipulation: true
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        type: 'number',
                        unit: '$',
                        editable: true,
                        value: ''
                    }, {
                        editable: false,
                        tooltip: 'cam / total_sq_ft',
                        getComputedValue(tabs, precomputedValues, rowIndex) {
                            const totalSpace = tabs['current-rr-tab'].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                            const current = tabs['expenses-tab'].tables['expenses'].rows[rowIndex].valueCells[2].value;
                            const value = parseFloat(current / totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value)  || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        type: 'number',
                        unit: '$',
                        editable: true,
                        hidden: true,
                        value: ''
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: 'cam / total_sq_ft',
                        getComputedValue(tabs, precomputedValues, rowIndex) {
                            const totalSpace = tabs['current-rr-tab'].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                            const current = tabs['expenses-tab'].tables['expenses'].rows[rowIndex].valueCells[5].value;
                            const value = parseFloat(current / totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, { // leave ARCIMEDES_ROW_ID as the last cell
                        type: 'string',
                        editable: true,
                        hidden: true,
                        value: '',
                    },]
                },
                'cam-3': {
                    valueCells: [{
                        editable: true,
                        value: '',
                        hasRowManipulation: true
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        type: 'number',
                        unit: '$',
                        editable: true,
                        value: ''
                    }, {
                        editable: false,
                        tooltip: 'cam / total_sq_ft',
                        getComputedValue(tabs, precomputedValues, rowIndex) {
                            const totalSpace = tabs['current-rr-tab'].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                            const current = tabs['expenses-tab'].tables['expenses'].rows[rowIndex].valueCells[2].value;
                            const value = parseFloat(current / totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value)  || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        type: 'number',
                        unit: '$',
                        editable: true,
                        hidden: true,
                        value: ''
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: 'cam / total_sq_ft',
                        getComputedValue(tabs, precomputedValues, rowIndex) {
                            const totalSpace = tabs['current-rr-tab'].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                            const current = tabs['expenses-tab'].tables['expenses'].rows[rowIndex].valueCells[5].value;
                            const value = parseFloat(current / totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, { // leave ARCIMEDES_ROW_ID as the last cell
                        type: 'string',
                        editable: true,
                        hidden: true,
                        value: '',
                    },]
                },
                'cam-4': {
                    valueCells: [{
                        editable: true,
                        value: '',
                        hasRowManipulation: true
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        type: 'number',
                        unit: '$',
                        editable: true,
                        value: ''
                    }, {
                        editable: false,
                        tooltip: 'cam / total_sq_ft',
                        getComputedValue(tabs, precomputedValues, rowIndex) {
                            const totalSpace = tabs['current-rr-tab'].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                            const current = tabs['expenses-tab'].tables['expenses'].rows[rowIndex].valueCells[2].value;
                            const value = parseFloat(current / totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value)  || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        type: 'number',
                        unit: '$',
                        editable: true,
                        hidden: true,
                        value: ''
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: 'cam / total_sq_ft',
                        getComputedValue(tabs, precomputedValues, rowIndex) {
                            const totalSpace = tabs['current-rr-tab'].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                            const current = tabs['expenses-tab'].tables['expenses'].rows[rowIndex].valueCells[5].value;
                            const value = parseFloat(current / totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, { // leave ARCIMEDES_ROW_ID as the last cell
                        type: 'string',
                        editable: true,
                        hidden: true,
                        value: '',
                    },]
                },
                'cam-5': {
                    valueCells: [{
                        editable: true,
                        value: '',
                        hasRowManipulation: true
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        type: 'number',
                        unit: '$',
                        editable: true,
                        value: ''
                    }, {
                        editable: false,
                        tooltip: 'cam / total_sq_ft',
                        getComputedValue(tabs, precomputedValues, rowIndex) {
                            const totalSpace = tabs['current-rr-tab'].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                            const current = tabs['expenses-tab'].tables['expenses'].rows[rowIndex].valueCells[2].value;
                            const value = parseFloat(current / totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value)  || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        type: 'number',
                        unit: '$',
                        editable: true,
                        hidden: true,
                        value: ''
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: 'cam / total_sq_ft',
                        getComputedValue(tabs, precomputedValues, rowIndex) {
                            const totalSpace = tabs['current-rr-tab'].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                            const current = tabs['expenses-tab'].tables['expenses'].rows[rowIndex].valueCells[5].value;
                            const value = parseFloat(current / totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, { // leave ARCIMEDES_ROW_ID as the last cell
                        type: 'string',
                        editable: true,
                        hidden: true,
                        value: '',
                    },]
                },
                'total-cam': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Total CAM'};
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        getComputedValue(tabs, precomputedValues) {
                            let value = 0;
                            const rows = tabs['expenses-tab'].tables['expenses'].rows;
                            const arrayRows = Object.entries(rows);
                            let {lastCamRowIndex, camNo} = UnderwritingMultiTenant.findCamRowNO(arrayRows);
                            for (let i = 1; i <= camNo; i++) {
                                const camRow = rows[`cam-${i}`];
                                if (camRow && camRow.valueCells[2].value) {
                                    value += parseFloat(camRow.valueCells[2].value);
                                }
                            }
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        tooltip: 'total_cam / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const totalSpace = tabs['current-rr-tab'].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                            const current = tabs['expenses-tab'].tables['expenses'].rows['total-cam'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(current / totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value)  || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: 'total_cam / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            let value = 0;
                            const rows = tabs['expenses-tab'].tables['expenses'].rows;
                            const arrayRows = Object.entries(rows);
                            let {lastCamRowIndex, camNo} = UnderwritingMultiTenant.findCamRowNO(arrayRows);
                            for (let i = 1; i <= camNo; i++) {
                                const camRow = rows[`cam-${i}`];
                                if (camRow && camRow.valueCells[5].value) {
                                    value += parseFloat(camRow.valueCells[5].value);
                                }
                            }
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue(tabs, precomputedValues) {
                            const totalSpace = tabs['current-rr-tab'].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                            const current = tabs['expenses-tab'].tables['expenses'].rows['total-cam'].valueCells[5].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(current / totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    },]
                },
                'management-fee': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Management Fee (% of GPI)'};
                        }
                    }, {
                        editable: false,
                        tooltip: 'effective_gross_revenue / management_fee',
                        getComputedValue(tabs, precomputedValues) {
                            const current = tabs['expenses-tab'].tables['expenses'].rows['management-fee'].valueCells[2].value;
                            const effectiveGrossIncome = tabs['expenses-tab'].tables['expenses'].rows['effective-gross-revenue'].valueCells[1].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(current / effectiveGrossIncome * 100);
                            const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    }, {
                        type: 'number',
                        unit: '$',
                        editable: true,
                        value: ''
                    }, {
                        editable: false,
                        tooltip: 'management_fee / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const totalSpace = tabs['current-rr-tab'].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                            const current = tabs['expenses-tab'].tables['expenses'].rows['management-fee'].valueCells[2].value;
                            const value = parseFloat(current / totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        tooltip: 'effective_gross_revenue / management_fee',
                        getComputedValue(tabs, precomputedValues) {
                            const current = tabs['expenses-tab'].tables['expenses'].rows['management-fee'].valueCells[5].value;
                            const effectiveGrossIncome = tabs['expenses-tab'].tables['expenses'].rows['effective-gross-revenue'].valueCells[4].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(current / effectiveGrossIncome * 100);
                            const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    }, {
                        type: 'number',
                        unit: '$',
                        editable: true,
                        hidden: true,
                        value: ''
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: 'management_fee / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const totalSpace = tabs['current-rr-tab'].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                            const current = tabs['expenses-tab'].tables['expenses'].rows['management-fee'].valueCells[5].value;
                            const value = parseFloat(current / totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },]
                },
                'effective-gross-revenue': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Effective Gross Revenue'};
                        }
                    }, {
                        editable: false,
                        getComputedValue(tabs, precomputedValues) {
                            const value = tabs['pricing-tab'].tables['total-gross-revenue'].footerRow.valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue(tabs, precomputedValues) {
                            const value = tabs['pricing-tab'].tables['total-gross-revenue'].footerRow.valueCells[6].getComputedValue(tabs, precomputedValues).internalValue;
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    },]
                },
                'non-reimbursable-expenses': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'Non-Reimbursable Expenses'};
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        type: 'number',
                        unit: '$',
                        editable: true,
                        value: ''
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    }, {
                        type: 'number',
                        unit: '$',
                        editable: true,
                        value: '',
                        hidden: true,
                    }, {
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''};
                        }
                    },]
                },
                'footer': {
                    valueCells: [{
                        editable: false,
                        getComputedValue() {
                            return {displayValue: 'TOTAL EXPENSES'}
                        }
                    }, {
                        editable: false,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        tooltip: 'real_estate_taxes + insurance + total_cam + management_fee + non_reimbursable_expenses',
                        getComputedValue(tabs, precomputedValues) {
                            const realEstateTaxes = parseFloat(tabs['expenses-tab'].tables['expenses'].rows['real-estate-taxes'].valueCells[2].value || 0);
                            const insurance = parseFloat(tabs['expenses-tab'].tables['expenses'].rows['insurance'].valueCells[2].value || 0);
                            const totalCAM = parseFloat(tabs['expenses-tab'].tables['expenses'].rows['total-cam'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue || 0);
                            const managementFee = parseFloat(tabs['expenses-tab'].tables['expenses'].rows['management-fee'].valueCells[2].value || 0);
                            const nonReimbursableExpenses = parseFloat(tabs['expenses-tab'].tables['expenses'].rows['non-reimbursable-expenses'].valueCells[2].value || 0);
                            const value = realEstateTaxes + insurance + totalCAM + managementFee + nonReimbursableExpenses;
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        tooltip: 'total_expenses / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const totalSpace = tabs['current-rr-tab'].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                            const current = tabs['expenses-tab'].tables['expenses'].rows['footer'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(current / totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value)  || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, { // Pro Forma
                        editable: false,
                        hidden: true,
                        getComputedValue() {
                            return {displayValue: ''}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: 'real_estate_taxes + insurance + total_cam + management_fee + non_reimbursable_expenses',
                        getComputedValue(tabs, precomputedValues) {
                            const realEstateTaxes = parseFloat(tabs['expenses-tab'].tables['expenses'].rows['real-estate-taxes'].valueCells[5].value || 0);
                            const insurance = parseFloat(tabs['expenses-tab'].tables['expenses'].rows['insurance'].valueCells[5].value || 0);
                            const totalCAM = parseFloat(tabs['expenses-tab'].tables['expenses'].rows['total-cam'].valueCells[5].getComputedValue(tabs, precomputedValues).internalValue || 0);
                            const managementFee = parseFloat(tabs['expenses-tab'].tables['expenses'].rows['management-fee'].valueCells[5].value || 0);
                            const nonReimbursableExpenses = parseFloat(tabs['expenses-tab'].tables['expenses'].rows['non-reimbursable-expenses'].valueCells[5].value || 0);
                            const value = realEstateTaxes + insurance + totalCAM + managementFee + nonReimbursableExpenses;
                            const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    }, {
                        editable: false,
                        hidden: true,
                        tooltip: 'total_expenses / total_sq_ft',
                        getComputedValue(tabs, precomputedValues) {
                            const totalSpace = tabs['current-rr-tab'].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
                            const current = tabs['expenses-tab'].tables['expenses'].rows['footer'].valueCells[5].getComputedValue(tabs, precomputedValues).internalValue;
                            const value = parseFloat(current / totalSpace);
                            const displayValue = !value || value < 0 || isNaN(value) || !isFinite(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue}
                        }
                    },]
                }
            }
        }, 'expense-notes': {
            rows: {
                'expense-notes': {
                    valueCells: [{
                        editable: true,
                        value: ''
                    }]
                }
            }
        }
    }
}